module.exports = __webpack_public_path__ + "img/ps-27.0f4db09e.jpg";